<template>
    <div :class="'ses-content '+(onModal?'on-modal':'')">
        <!-- Header -->
        <content-header></content-header>

        <!-- Page content -->
        <div class="page-content">
          <div class="container main-content content" v-if="showMenu && $route.path !== '/reset'">
              <div class="col-md-3 sidebar_wrap">
                  <content-sidebar></content-sidebar>
              </div>
              <div class="col-md-9 content_wrap">
                  <reset-password-modal></reset-password-modal>
                  <slide-y-up-transition mode="out-in" origin="center top">
                      <router-view @modChange="modChange"></router-view>
                  </slide-y-up-transition>
              </div>
          </div>
          <div v-else-if="showMenu && $route.path === '/reset'" class="container content">
            <slide-y-up-transition mode="out-in" origin="center top">
              <router-view></router-view>
            </slide-y-up-transition>
          </div>
          <div v-else-if="loaded && !user.id" class="container content">
            <slide-y-up-transition mode="out-in" origin="center top">
              <router-view></router-view>
            </slide-y-up-transition>
          </div>
        </div>
    </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'
  import ContentHeader from './ContentHeader.vue'
  import ContentSidebar from './ContentSidebar.vue'
  import ResetPasswordModal from '../components/Modals/ResetPasswordModal'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition,
      ContentHeader,
      ContentSidebar,
      ResetPasswordModal
    },
    data() {
      return {
        onModal: false,
        showMenu: false,
        loaded: false,
        user: {},
        publicRoutes: [
          '/login',
          // '/reset',
          '/register',
          '/technical-documents',
          '/training-videos',
          '/service-videos',
          '/brakeadjustment'
        ]
      }
    },
    watch: {
        '$route': function() {
            this.onModal = false;
        }
    },
    mounted() {
      this.$http.get('/api/update_user_reward/login').catch(() => {})
    },
    methods: {
      modChange(change) {
        this.onModal = change;
        console.log('modchange',change);
      },
      checklogin() {
        var user = localStorage.getItem('user'),
          need_reset = localStorage.getItem('need_reset');
        let public_routes = [
          '/login',
          '/register',
          '/technical-documents',
          '/training-videos',
          '/service-videos',
          '/brakeadjustment'
        ]

        if ( !user && !public_routes.includes(this.$route.path) ) {
          this.loaded = true;
          this.$router.push('login');
        }
        else if (!user && this.publicRoutes.includes(this.$route.path)) {
          this.loaded = true;
        }
        else if ( user && this.$route.path === '/login' ) {
          this.loaded = true;
          this.$router.push('list');
        }
        else if ( need_reset && this.$route.path !== '/reset') {
          this.loaded = true;
          this.$router.push('/reset').catch(() => {});
        }
        else {
          this.$http.get('/api/me').then((r) => {
            localStorage.setItem('user', JSON.stringify(r.data));
            user = r.data;
            this.showMenu = user && !user.need_reset && true;
            this.user = user;
          }).catch(() => {});
        }
      }
    },
    beforeMount(){
        this.checklogin()
    }
  }
</script>
